import { roleVariant } from '../lib/systemRoles';

export function RolePill({ role, title }: { role: string; title?: string }) {
  return (
    <span className={`role-pill role-${roleVariant(role)}`} title={title}>
      {role}
    </span>
  );
}
